module.exports = __webpack_public_path__ + "static/media/bgFree.c0b3740a.png";